export function windowWidth() {
  return document.body.clientWidth || window.innerWidth
}
